<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>库存记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10" class="search-wrapper">
      <el-col :span="3">
        <div class="grid-content">
          <el-select v-model="action" clearable placeholder="变更类型" style="width: 100%;">
            <el-option
              v-for="item in actionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-select v-model="schoolId" clearable placeholder="学校名称" style="width: 100%;">
            <el-option
              v-for="item in schoolOptions"
              :key="item.uuid"
              :label="item.schoolName"
              :value="item.uuid">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-input placeholder="教练NO" v-model="insNo">
            <template slot="prepend">个人库存</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="4" style="padding-left: 0">
        <div class="grid-content">
          <el-select v-model="courseId" clearable placeholder="课程" style="width: 100%;">
            <el-option
              v-for="item in courseOptions"
              :key="item.courseId"
              :label="item.name"
              :value="item.courseId">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content">
          <el-button
            style="width: 100%;"
            type="primary"
            @click="search"
          >查询
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-table
      class="table"
      :data="stockList"
      :max-height="tableHeight"
      style="width: 100%">
      <el-table-column
        prop="actionDesc"
        label="变更类型"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="ownerName"
        label="库存所有人"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="srcUserName"
        label="操作人"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="dstUserName"
        label="变更目标"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="courseName"
        label="课程名称"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="courseNameEnglish"
        label="课程英文名"
        align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="qty"
        label="数量"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="entryTime"
        label="更新时间"
        align="center"
        width="150">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @current-change="handleCurrentChange"
      prev-text="上一页"
      next-text="下一页"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '@/common/js/config';
  import { getSchools } from '@/api/order';
  import { getStockList, getCourses } from '@/api/stock';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'stock_list',
    data() {
      return {
        actionOptions: [{
          value: 0,
          label: '购买'
        }, {
          value: 1,
          label: '绑定'
        }, {
          value: 2,
          label: '认证'
        }, {
          value: 3,
          label: '转让'
        }],
        schoolOptions: [],
        schoolId: '',
        courseOptions: [],
        courseId: '',
        action: null,
        insNo: '',
        courseName: '',
        currentPage: 1,
        total: 0,
        tableHeight: 500,
        pageSize: 3
      };
    },
    created() {
      this._getSchools();
      this._getCourses();
      if (!this.$route.params.pageNum) {
        this.$router.push('/stock_list/1');
        this.currentPage = 1;
        this._getStockList(1);
      } else {
        this._getStockList(this.$route.params.pageNum);
        this.currentPage = parseInt(this.$route.params.pageNum);
      }
    },
    mounted() {
      let orderHeight = document.body.clientHeight;
      this.tableHeight = orderHeight - 284;
    },
    methods: {
      search() {
        this.$router.push('/stock_list/1');
        this.currentPage = 1;
        this._getStockList(1);
      },
      goToDetail(order) {
        this.$router.push(`/order_detail/${order.id}`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.$router.push(`/stock_list/${val}`);
        this._getStockList(val);
      },
      _getSchools() {
        getSchools(this.user.userId).then((res) => {
          this.schoolOptions = res.schools;
        });
      },
      _getCourses() {
        getCourses(this.user.userId).then((res) => {
          this.courseOptions = res.courses;
        });
      },
      _getStockList(pageNum) {
        getStockList(
          this.user.userId,
          pageNum,
          this.action,
          this.schoolId,
          this.insNo,
          this.courseId,
        ).then((res) => {
          this.total = res.count;
          this.pageSize = res.pageSize;
          this.setList({
            list: res.courseStockExList,
            type: listType.STOCK
          });
        });
      },
      ...mapActions([
        'setList',
        'setItem'
      ])
    },
    computed: {
      ...mapGetters([
        'stockList',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    overflow: scroll;
    .title
      margin-bottom: 20px;
    .search-wrapper
      margin: 0 0 10px 0 !important;
    .add-btn
      margin-bottom: 10px;
    .pagination
      margin-top: 10px;
</style>